export default __webpack_public_path__ + "static/0226-071c338ec3324569f494f02af4135d13.png";